import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  viewPrices: { id: 'plans_page_v4_cta' },
});

export const FooterButtons: FC<{
  onViewPrices: () => void;
  secondaryAction?: {
    text: string;
    onClick: () => void;
  };
}> = ({ onViewPrices, secondaryAction }) => {
  const intl = useIntl();

  return (
    <S.ButtonsWrapper>
      <Button buttonType="primary" buttonSize="medium" wide onClick={onViewPrices}>
        {intl.formatMessage(msgs.viewPrices)}
      </Button>

      {secondaryAction && (
        <Button buttonType="secondary" buttonSize="medium" wide onClick={secondaryAction.onClick}>
          {secondaryAction.text}
        </Button>
      )}
    </S.ButtonsWrapper>
  );
};
